import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Link } from 'react-router-dom';
import cx from 'clsx';
import { useTheme } from '../../../ThemeProvider';
import GithubButton from '../../GithubButton/GithubButton';
import settings from '../../../settings';
import classes from './Footer.styles.less';
export default function Footer({ className }) {
    const [theme] = useTheme();
    const tools = settings.tools.map((tool) => (_jsx(Link, { className: classes.link, to: tool.link, children: tool.name }, tool.name)));
    const links = settings.meta.map((link, index) => {
        const { internal, label, ...linkProps } = link;
        if (internal) {
            return (_jsx(Link, { className: classes.link, to: String(linkProps.to), children: label }, index));
        }
        return (_jsx("a", { className: classes.link, href: String(linkProps.href), target: "_blank", rel: "noopener noreferrer", children: label }, index));
    });
    return (_jsx("footer", { className: cx(classes.footer, classes[theme], className), children: _jsxs("div", { className: classes.inner, children: [_jsxs("div", { className: classes.main, children: [_jsxs("div", { className: classes.links, children: [_jsx("h3", { className: classes.title, children: "Tools" }), _jsx("div", { className: classes.chunks, children: tools })] }), _jsxs("div", { className: classes.links, children: [_jsx("h3", { className: classes.title, children: "Application" }), links] })] }), _jsx("div", { className: classes.control, children: _jsx(GithubButton, {}) })] }) }));
}
